import { OpenInNewRounded } from '@mui/icons-material'
import { Box, Button, ButtonGroup, IconButton, Typography, useTheme } from '@mui/material'
import { useAppDispatch } from '../../../store/Hooks'
import { changeRoute } from '../../../store/slices/SessionSlice'
import { Route } from '../../routing/Routing'

interface P {
    title: string
    chart?: JSX.Element | JSX.Element[]
    link?: { route: Route, params?: any }
    options?: { label: string, onClick: () => void, isActive?: boolean }[]
}

function ChartCard({ title, chart, link, options }: P) {
    const theme = useTheme()
    const dispatch = useAppDispatch()
    return (
        <Box display='flex' flex={1} flexDirection='column' gap={1} height='100%'>
            <Box display='flex' flexDirection='row' justifyContent='space-between' gap={1}>
                <Typography variant='h6'>{title}</Typography>
                <Box>
                    {options && (
                        <ButtonGroup size='small'>
                            {options?.map(x => <Button sx={{ backgroundColor: x.isActive && theme.palette.action.selected }} key={x.label} onClick={x.onClick}>{x.label}</Button>)}
                        </ButtonGroup>
                    )}
                    {link && (
                        <IconButton sx={{ marginLeft: 1 }} size='small' onClick={() => dispatch(changeRoute(link))}>
                            <OpenInNewRounded fontSize='inherit' />
                        </IconButton>
                    )}
                </Box>
            </Box>
            <Box display='flex' flex={1} height='100%'>
                {chart}
            </Box>
        </Box>
    )
}

export default ChartCard
